module.exports = __webpack_public_path__ + "img/airplanemode_android@3x.872aecf8.jpg";